import axios from 'axios';

export const setupInterceptors = () => {
    // Set up interceptors once
    axios.interceptors.request.use(req => {
        const currentToken = localStorage.getItem("token");
        if (currentToken) {
            req.headers.authorization = 'Bearer ' + currentToken;
        }
        return req;
    });

    axios.interceptors.response.use(
        res => res,
        err => {
            console.log("Response interceptor - Error:", err?.response?.status, "URL:", err?.config?.url);
            if (err?.response?.status === 401) {
                console.log("401 Unauthorized - Clearing token and redirecting to login");
                // Token expired or unauthorized access, clear token and redirect to login
                localStorage.removeItem('token');
                
                // Instead of forcing a page reload, dispatch a logout action
                // This will let React handle the routing properly
                if (window.location.pathname !== '/login') {
                    // Dispatch a custom event that the App component can listen to
                    window.dispatchEvent(new CustomEvent('tokenExpired'));
                } else {
                    // If we're already on login page, just clear the token
                    // The App component will handle the state update
                    console.log("Already on login page, just clearing token");
                }
            } else if (err?.response?.status === 404) {
                throw new Error(`${err.config.url} not found`);
            } else {
                console.error(err);
            }
            return Promise.reject(err);
        }
    );
}

setupInterceptors();

export const request = () => {
    // This function is now a no-op, but we keep it for compatibility
    // with the existing code that calls it.
    return Promise.resolve();
}

export const updateToken = (newToken) => {
    if (newToken) {
        localStorage.setItem('token', newToken);
    } else {
        localStorage.removeItem('token');
    }
}